import { Mail } from "lucide-react";
import Seo from "../components/Seo";
import ContactForm from "../components/forms/ContactForm";
import { SITE } from "../config/site";

export default function Contact() {
  return (
    <main data-testid="contact-page" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-20">
      <Seo
        title="Contact — Essex Black Cab"
        description="Contact Essex Black Cab about a £100 fixed-fare journey request between Essex and London, driver applications or anything else."
      />
      <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr]">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Contact</p>
          <h1 className="mt-3 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Get in touch
          </h1>
          <p className="mt-4 leading-relaxed text-[#A1A1AA]">
            Questions about a journey, the fixed fare, or joining as a driver? Send a message
            and we will reply as soon as possible.
          </p>
          <div className="mt-8 flex items-start gap-4 border border-[#27272A] bg-[#111111] p-6">
            <Mail className="mt-1 h-6 w-6 shrink-0 text-[#D4AF37]" aria-hidden="true" />
            <div>
              <h2 className="text-lg font-semibold text-white">Message us</h2>
              <p className="mt-1 text-sm leading-relaxed text-[#A1A1AA]">
                The quickest way to reach us is the contact form — every message is delivered
                directly to our business inbox and we reply as soon as possible.
                {SITE.email && (
                  <>
                    {" "}
                    You can also email us at{" "}
                    <a
                      href={`mailto:${SITE.email}`}
                      data-testid="contact-email-link"
                      className="focus-gold text-[#D4AF37] underline-offset-4 hover:underline"
                    >
                      {SITE.email}
                    </a>
                    .
                  </>
                )}
              </p>
              <p className="mt-2 text-sm text-[#71717A]">
                For journey requests, please use the{" "}
                <a href="/book" className="text-[#D4AF37] underline-offset-4 hover:underline">
                  booking request form
                </a>{" "}
                so we have all the details we need.
              </p>
            </div>
          </div>
        </div>
        <div className="border border-[#27272A] bg-[#0B0B0B] p-6 sm:p-10">
          <ContactForm />
        </div>
      </div>
    </main>
  );
}
